import { usePocQuery } from 'core/custom-hooks/use-poc-query.hook';
import { materialDefinitionKeys } from 'core/query-client/keys';
import { executeRequest } from 'core/utils/backend-service';
import { getMaterialDefinitionById } from '../material-definitions.service';

export const useMaterialDefinitionById = (id: string | undefined, enabled: boolean) => {
    const { data, isLoading, isError } = usePocQuery({
        queryKey: materialDefinitionKeys.detail(id!),
        queryFn: () => executeRequest(() => getMaterialDefinitionById(id!)),
        enabled: enabled && Boolean(id),
    });

    return { material: data, isLoading, isError };
};
